import { render, staticRenderFns } from "./teach-someone.vue?vue&type=template&id=35e03736&"
import script from "./teach-someone.vue?vue&type=script&lang=js&"
export * from "./teach-someone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports